import { IBarChartParamValue } from './barChartParams';
import { IGroupedBarChartData } from './groupedBarChart';

const PREVIEW_COLORS: Array<string> = ['#FF5A00', '#FF0000', '#2F80ED', '#E5B60E', '#1AA932'];

export function buildGroupedBarChartTemplateData(
	metrics: Array<IBarChartParamValue>
): IGroupedBarChartData {
	const categories = metrics.map((metric, index) => ({
		key: metric.key,
		name: metric.title,
		color: PREVIEW_COLORS[index % PREVIEW_COLORS.length],
	}));

	return {
		title: '',
		categories,
		series: new Array(100).fill('').map((_, index) => ({
			name: 'Shop ' + (index + 1),
			values: categories.map(() => Math.floor(Math.random() * 90) + 10),
		})),
	};
}
